// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBQAB7fG6GyYR2vRKKxd6tP2TXrS4o3ydw",
  authDomain: "weatherapp-b5c8b.firebaseapp.com",
  projectId: "weatherapp-b5c8b",
  storageBucket: "weatherapp-b5c8b.appspot.com",
  messagingSenderId: "844380712953",
  appId: "1:844380712953:web:f99a17623310c417c0d728"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;